import { createRouter, createWebHistory } from "vue-router";

import HomeView from "../views/HomeView.vue";

// import { initializeGuards } from './guards'

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/LoginView.vue"),
  },
  {
    path: "/register",
    name: "register",
    component: () => import("../views/RegisterView.vue"),
  },
  {
    path: "/forgot-password",
    name: "forgot-password",
    component: () => import("../views/ForgotPasswordView.vue"),
  },
  {
    path: "/reset-password",
    name: "reset-password",
    component: () => import("../views/ResetPasswordView.vue"),
  },
  {
    path: "/online-applications",
    name: "online-applications",
    component: () => import("../views/ApplicationsView.vue"),
  },
  {
    path: "/online-applications/:applicationId/revise",
    name: "application-revise",
    component: () => import("../views/ApplicationRevisionView.vue"),
    props: true,
  },
  {
    path: "/online-applications/:applicationId/payment-receipt",
    name: "application-payment-receipt",
    component: () => import("../views/PaymentReceiptView.vue"),
    props: true,
  },
  {
    path: "/tvet-trainers",
    name: "tvet-trainers",
    component: () => import("../views/TrainersView.vue"),
  },
  {
    path: "/resource-hub",
    name: "resource-hub",
    component: () => import("../views/ResourceHubView.vue"),
  },
  {
    path: "/announcements",
    name: "public-announcements",
    component: () => import("../views/PublicAnnouncementsView.vue"),
  },
  {
    path: "/tvet-institutions",
    name: "tvet-institutions",
    component: () => import("../views/TVETDirectoryView.vue"),
  },
  {
    path: "/register-institution",
    name: "register-institution",
    component: () => import("../views/RegisterInstitutionView.vue"),
  },
  {
    path: "/register-trainer",
    name: "register-trainer",
    component: () => import("../views/RegisterTrainerView.vue"),
  },
  {
    path: "/job-marketplace",
    name: "job-marketplace",
    component: () => import("../views/JobMarketplaceView.vue"),
  },
  {
    path: "/admin",
    component: () => import("../layouts/AdminLayout.vue"),
    children: [
      {
        path: "",
        redirect: "/admin/dashboard",
      },
      {
        path: "dashboard",
        name: "admin-dashboard",
        component: () => import("../views/dashboards/IndexView.vue"),
      },
      {
        path: "profile",
        name: "user-profile",
        component: () => import("../views/ProfileView.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "analytics",
        name: "admin-analytics",
        component: () =>
          import("../views/dashboards/administrator/IndexView.vue"),
      },
      {
        path: "admin-institutions",
        name: "admin-institutions",
        redirect: { name: "institution-dashboard" },
      },
      {
        path: "institutions",
        name: "institutions",
        component: () => import("../views/InstitutionsView.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "courses",
        name: "courses",
        component: () => import("../views/admin/CoursesView.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "lessons",
        name: "lessons",
        component: () => import("../views/admin/LessonsView.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "trainers",
        name: "trainers",
        component: () => import("../views/admin/TrainersView.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "students-crud",
        name: "students-crud",
        component: () => import("../views/admin/StudentsView.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "students",
        name: "admin-students",
        redirect: { name: "student-index" },
      },
      {
        path: "student",
        name: "student-dashboard",
        meta: { requiresAuth: true, role: "Student" },
        children: [
          {
            path: "",
            name: "student-index",
            component: () => import("../views/admin/student/DashboardView.vue"),
          },
          {
            path: "lessons",
            name: "student-lessons",
            component: () => import("../views/admin/student/LessonsView.vue"),
          },
        ],
      },
      {
        path: "trainer",
        name: "trainer-dashboard",
        meta: { requiresAuth: true, role: "Trainer" },
        children: [
          {
            path: "",
            name: "trainer-index",
            component: () => import("../views/admin/trainer/DashboardView.vue"),
          },
          {
            path: "lessons",
            name: "trainer-lessons",
            component: () => import("../views/admin/trainer/LessonsView.vue"),
          },
        ],
      },
      {
        path: "institutional-admin",
        name: "institutional-admin-dashboard",
        meta: { requiresAuth: true, role: "Institutional Admin" },
        children: [
          {
            path: "",
            name: "institutional-admin-index",
            redirect: { name: "institution-dashboard" },
          },
          {
            path: "students",
            name: "institutional-admin-students",
            component: () =>
              import("../views/admin/institutional-admin/StudentsView.vue"),
          },
          {
            path: "trainers",
            name: "institutional-admin-trainers",
            redirect: { name: "institution-trainers" },
          },
          {
            path: "courses",
            name: "institutional-admin-courses",
            redirect: { name: "institution-courses" },
          },
          {
            path: "examinations",
            name: "institutional-admin-examinations",
            component: () =>
              import("../views/admin/institutional-admin/ExaminationsView.vue"),
          },
          {
            path: "assessments",
            name: "institutional-admin-assessments",
            component: () =>
              import("../views/admin/institutional-admin/AssessmentsView.vue"),
          },
          {
            path: "resources",
            name: "institutional-admin-resources",
            component: () =>
              import("../views/admin/institutional-admin/ResourcesView.vue"),
          },
          {
            path: "enrollments",
            name: "institutional-admin-enrollments",
            component: () =>
              import("../views/admin/institutional-admin/EnrollmentsView.vue"),
          },
          {
            path: "qualifications",
            name: "institutional-admin-qualifications",
            component: () =>
              import(
                "../views/admin/institutional-admin/QualificationsView.vue"
              ),
          },
          {
            path: "curricula",
            name: "institutional-admin-curricula",
            component: () =>
              import("../views/admin/institutional-admin/CurriculaView.vue"),
          },
          {
            path: "exam-results",
            name: "institutional-admin-exam-results",
            component: () =>
              import("../views/admin/institutional-admin/ExamResultsView.vue"),
          },
          {
            path: "assessment-results",
            name: "institutional-admin-assessment-results",
            component: () =>
              import(
                "../views/admin/institutional-admin/AssessmentResultsView.vue"
              ),
          },
        ],
      },
      {
        path: "institution",
        meta: { requiresAuth: true, role: "Institutional Admin" },
        children: [
          {
            path: "",
            name: "institution-dashboard",
            component: () =>
              import("../views/admin/institution/DashboardView.vue"),
          },
          {
            path: "courses",
            name: "institution-courses",
            component: () =>
              import("../views/admin/institution/CoursesView.vue"),
          },
          {
            path: "trainers",
            name: "institution-trainers",
            component: () =>
              import("../views/admin/institution/TrainersView.vue"),
          },
          {
            path: "students",
            name: "institution-students",
            component: () =>
              import("../views/admin/institution/StudentsView.vue"),
          },
          {
            path: "departments",
            redirect: { name: "institution-sections" },
          },
          {
            path: "sections",
            name: "institution-sections",
            component: () =>
              import("../views/admin/institution/SectionsView.vue"),
          },
          {
            path: "lessons",
            name: "institution-lessons",
            component: () =>
              import("../views/admin/institution/LessonsView.vue"),
          },
          {
            path: "timetable",
            name: "institution-timetable",
            component: () =>
              import("../views/admin/institution/TimetableView.vue"),
          },
          {
            path: "attendance",
            name: "institution-attendance",
            component: () =>
              import("../views/admin/institution/AttendanceView.vue"),
          },
          {
            path: "assessments",
            name: "institution-assessments",
            component: () =>
              import("../views/admin/institution/AssessmentsView.vue"),
          },
          {
            path: "facilities",
            name: "institution-facilities",
            component: () =>
              import(
                "../views/admin/institution/FacilitiesInfrastructureView.vue"
              ),
          },
          {
            path: "expenses",
            name: "institution-expenses",
            component: () =>
              import("../views/admin/institution/ExpensesView.vue"),
          },
          {
            path: "donations",
            name: "institution-donations",
            component: () =>
              import("../views/admin/institution/DonationsView.vue"),
          },
          {
            path: "inventory",
            name: "institution-inventory",
            component: () =>
              import("../views/admin/institution/InventoryView.vue"),
          },
          {
            path: "announcements",
            name: "institution-announcements",
            component: () =>
              import("../views/admin/institution/AnnouncementsView.vue"),
          },
          {
            path: "resources",
            name: "institution-resources",
            component: () =>
              import("../views/admin/institution/ResourcesView.vue"),
          },
          {
            path: "activity-logs",
            name: "institution-activity-logs",
            component: () =>
              import("../views/admin/institution/ActivityLogsView.vue"),
          },
          {
            path: "emails",
            name: "institution-emails",
            component: () => import("../views/admin/EmailsView.vue"),
          },
        ],
      },
      {
        path: "molsa-admin",
        name: "molsa-admin-dashboard",
        meta: { requiresAuth: true, role: "MoLSA Central Admin" },
        children: [
          {
            path: "",
            name: "molsa-admin-index",
            component: () => import("../views/admin/molsa-admin/DashboardView.vue"),
          },
          {
            path: "applications",
            name: "molsa-admin-applications",
            component: () =>
              import("../views/admin/molsa-admin/ApplicationApprovals.vue"),
          },
          {
            path: "application-approvals",
            redirect: { name: "molsa-admin-applications" },
          },
          {
            path: "registration-certificates",
            name: "molsa-admin-registration-certificates",
            component: () =>
              import("../views/admin/molsa-admin/RegistrationCertificate.vue"),
          },
          {
            path: "institution-applications",
            name: "molsa-admin-institution-applications",
            component: () =>
              import("../views/admin/molsa-admin/InstitutionApplications.vue"),
          },
          {
            path: "institution-application/:id",
            name: "molsa-admin-institution-application",
            component: () =>
              import("../views/admin/molsa-admin/InstitutionApplication.vue"),
          },
          {
            path: "trainer-applications",
            name: "molsa-admin-trainer-applications",
            component: () =>
              import("../views/admin/molsa-admin/TrainerApplications.vue"),
          },
          {
            path: "trainer-application/:id",
            name: "molsa-admin-trainer-application",
            component: () =>
              import("../views/admin/molsa-admin/TrainerApplication.vue"),
          },
          {
            path: "approval-workflows",
            name: "molsa-admin-approval-workflows",
            component: () =>
              import("../views/admin/molsa-admin/ApprovalWorkflowsView.vue"),
          },
          {
            path: "workflows",
            name: "molsa-admin-workflows",
            component: () =>
              import("../views/admin/molsa-admin/WorkflowsView.vue"),
          },
          // {
          //   path: "applications",
          //   name: "molsa-admin-applications",
          //   meta: { requiresAuth: true, role: "MoLSA Central Admin" },
          //   children: [
          //     {
          //       path: "",
          //       name: "student-index",
          //       component: () => import("../views/admin/student/IndexView.vue"),
          //     },
          //   ],
          // },
          {
            path: "institutions",
            name: "molsa-admin-institutions",
            component: () =>
              import("../views/admin/molsa-admin/InstitutionsView.vue"),
          },
          {
            path: "institutions/add",
            name: "molsa-admin-institutions-admin-add",
            component: () =>
              import("../views/admin/molsa-admin/AddInstitutionView.vue"),
          },
          {
            path: "trainers",
            name: "molsa-admin-trainers",
            component: () =>
              import("../views/admin/molsa-admin/TrainersView.vue"),
          },
          {
            path: "trainers/add",
            name: "molsa-admin-trainers-admin-add",
            component: () =>
              import("../views/admin/molsa-admin/AddTrainerView.vue"),
          },
          {
            path: "certificates",
            name: "molsa-admin-certificates",
            component: () =>
              import("../views/admin/molsa-admin/CertificatesView.vue"),
          },
          {
            path: "admins",
            name: "molsa-admin-admins",
            component: () =>
              import("../views/admin/molsa-admin/InstitutionAdmins.vue"),
          },
          {
            path: "institution-admins",
            redirect: { name: "molsa-admin-admins" },
          },
          {
            path: "admins/add",
            name: "molsa-admin-institutions-add",
            component: () =>
              import("../views/admin/molsa-admin/AddInstitutionAdminView.vue"),
          },
          {
            path: "reports",
            name: "molsa-admin-reports",
            component: () =>
              import("../views/admin/molsa-admin/ReportsView.vue"),
          },
          {
            path: "fms-officers",
            name: "molsa-admin-fms-officers",
            component: () =>
              import("../views/admin/molsa-admin/FMSOfficers.vue"),
          },
          {
            path: "courses",
            name: "molsa-admin-courses",
            component: () =>
              import("../views/admin/molsa-admin/CoursesView.vue"),
          },
          {
            path: "students",
            name: "molsa-admin-students",
            component: () =>
              import("../views/admin/molsa-admin/StudentsView.vue"),
          },
          {
            path: "activity-logs",
            name: "molsa-admin-activity-logs",
            component: () =>
              import("../views/admin/institution/ActivityLogsView.vue"),
          },
          {
            path: "emails",
            name: "molsa-admin-emails",
            component: () => import("../views/admin/EmailsView.vue"),
          },
        ],
      },
      {
        path: "administrator",
        name: "administrator-dashboard",
        meta: { requiresAuth: true, role: "Administrator" },
        children: [
          {
            path: "",
            name: "administrator-index",
            component: () =>
              import("../views/admin/administrator/DashboardView.vue"),
          },
          {
            path: "molsa-admins",
            name: "administrator-molsa-admins",
            component: () =>
              import("../views/admin/administrator/MolsaAdminsView.vue"),
          },
          {
            path: "applications",
            name: "administrator-applications",
            component: () =>
              import("../views/admin/administrator/ApplicationApprovals.vue"),
          },
          {
            path: "registration-certificates",
            name: "administrator-registration-certificates",
            component: () =>
              import("../views/admin/administrator/RegistrationCertificate.vue"),
          },
          {
            path: "fms-officers",
            name: "administrator-fms-officers",
            component: () =>
              import("../views/admin/administrator/FMSOfficers.vue"),
          },
          {
            path: "institutions",
            name: "administrator-institutions",
            component: () =>
              import("../views/admin/administrator/InstitutionsView.vue"),
          },
          {
            path: "admins",
            name: "administrator-admins",
            component: () =>
              import("../views/admin/administrator/InstitutionAdmins.vue"),
          },
          {
            path: "institution-admins",
            redirect: { name: "administrator-admins" },
          },
          {
            path: "trainers",
            name: "administrator-trainers",
            component: () =>
              import("../views/admin/administrator/TrainersView.vue"),
          },
          {
            path: "courses",
            name: "administrator-courses",
            component: () =>
              import("../views/admin/administrator/CoursesView.vue"),
          },
          {
            path: "students",
            name: "administrator-students",
            component: () =>
              import("../views/admin/administrator/StudentsView.vue"),
          },
          {
            path: "workflows",
            name: "administrator-workflows",
            component: () =>
              import("../views/admin/administrator/WorkflowsView.vue"),
          },
          {
            path: "institution-application/:id",
            name: "administrator-institution-application",
            component: () =>
              import("../views/admin/administrator/InstitutionApplication.vue"),
          },
          {
            path: "trainer-application/:id",
            name: "administrator-trainer-application",
            component: () =>
              import("../views/admin/administrator/TrainerApplication.vue"),
          },
          {
            path: "activity-logs",
            name: "administrator-activity-logs",
            component: () =>
              import("../views/admin/institution/ActivityLogsView.vue"),
          },
          {
            path: "website-traffic",
            name: "administrator-website-traffic",
            component: () =>
              import("../views/admin/administrator/WebsiteTrafficView.vue"),
          },
          {
            path: "emails",
            name: "administrator-emails",
            component: () => import("../views/admin/EmailsView.vue"),
          },
        ],
      },
      {
        path: "fms-admin",
        name: "fms-admin-dashboard",
        meta: { requiresAuth: true, role: "FMS TVET Officer" },
        children: [
          {
            path: "",
            name: "fms-admin-index",
            component: () => import("../views/admin/fms/DashboardView.vue"),
          },
          {
            path: "applications",
            name: "fms-admin-applications",
            component: () =>
              import("../views/admin/fms/OnlineApplicationsView.vue"),
          },
          {
            path: "applications/queue",
            name: "fms-admin-applications-queue",
            component: () =>
              import("../views/admin/fms/ApplicationApprovals.vue"),
          },
          {
            path: "application-approvals",
            redirect: { name: "fms-admin-applications" },
          },
          {
            path: "registration-certificates",
            name: "fms-admin-registration-certificates",
            component: () =>
              import("../views/admin/fms/RegistrationCertificate.vue"),
          },
          {
            path: "institution-applications",
            name: "fms-admin-institution-applications",
            component: () =>
              import("../views/admin/fms/InstitutionApplications.vue"),
          },
          {
            path: "institution-application/:id",
            name: "fms-admin-institution-application",
            component: () =>
              import("../views/admin/fms/InstitutionApplication.vue"),
          },
          {
            path: "trainer-applications",
            name: "fms-admin-trainer-applications",
            component: () =>
              import("../views/admin/fms/TrainerApplications.vue"),
          },
          {
            path: "trainer-application/:id",
            name: "fms-admin-trainer-application",
            component: () =>
              import("../views/admin/fms/TrainerApplication.vue"),
          },
          {
            path: "approval-workflows",
            name: "fms-admin-approval-workflows",
            component: () =>
              import("../views/admin/fms/ApprovalWorkflowsView.vue"),
          },
          {
            path: "workflows",
            name: "fms-admin-workflows",
            component: () =>
              import("../views/admin/fms/WorkflowsView.vue"),
          },
          {
            path: "institutions",
            name: "fms-admin-institutions",
            component: () =>
              import("../views/admin/fms/InstitutionsView.vue"),
          },
          {
            path: "institutions/add",
            name: "fms-admin-institutions-admin-add",
            component: () =>
              import("../views/admin/fms/AddInstitutionView.vue"),
          },
          {
            path: "trainers",
            name: "fms-admin-trainers",
            component: () =>
              import("../views/admin/fms/TrainersView.vue"),
          },
          {
            path: "trainers/add",
            name: "fms-admin-trainers-admin-add",
            component: () =>
              import("../views/admin/fms/AddTrainerView.vue"),
          },
          {
            path: "certificates",
            name: "fms-admin-certificates",
            component: () =>
              import("../views/admin/fms/CertificatesView.vue"),
          },
          {
            path: "admins",
            name: "fms-admin-admins",
            component: () =>
              import("../views/admin/fms/InstitutionAdmins.vue"),
          },
          {
            path: "institution-admins",
            redirect: { name: "fms-admin-admins" },
          },
          {
            path: "admins/add",
            name: "fms-admin-institutions-add",
            component: () =>
              import("../views/admin/fms/AddInstitutionAdminView.vue"),
          },
          {
            path: "reports",
            name: "fms-admin-reports",
            component: () => import("../views/admin/fms/ReportsView.vue"),
          },
          {
            path: "students",
            name: "fms-admin-students",
            component: () =>
              import("../views/admin/fms/StudentsView.vue"),
          },
          {
            path: "courses",
            name: "fms-admin-courses",
            component: () =>
              import("../views/admin/fms/CoursesView.vue"),
          },
          {
            path: "activity-logs",
            name: "fms-admin-activity-logs",
            component: () =>
              import("../views/admin/institution/ActivityLogsView.vue"),
          },
          {
            path: "emails",
            name: "fms-admin-emails",
            component: () => import("../views/admin/EmailsView.vue"),
          },
        ],
      },
      {
        path: "employer",
        name: "employer-dashboard",
        meta: { requiresAuth: true, role: "Employer" },
        children: [
          {
            path: "",
            name: "employer-index",
            component: () => import("../views/admin/employer/IndexView.vue"),
          },
          {
            path: "jobs",
            name: "employer-jobs",
            component: () => import("../views/admin/employer/JobsView.vue"),
          },
          {
            path: "applications",
            name: "employer-applications",
            component: () =>
              import("../views/admin/employer/ApplicationsView.vue"),
          },
          {
            path: "candidates",
            name: "employer-candidates",
            component: () =>
              import("../views/admin/employer/CandidatesView.vue"),
          },
          {
            path: "analytics",
            name: "employer-analytics",
            component: () =>
              import("../views/admin/employer/AnalyticsView.vue"),
          },
        ],
      },
      {
        path: "donor",
        name: "donor-dashboard",
        meta: { requiresAuth: true, role: "Donor" },
        children: [
          {
            path: "",
            name: "donor-index",
            component: () => import("../views/admin/donor/IndexView.vue"),
          },
          {
            path: "donations",
            name: "donor-donations",
            component: () => import("../views/admin/donor/DonationsView.vue"),
          },
          {
            path: "expenses",
            name: "donor-expenses",
            component: () => import("../views/admin/donor/ExpensesView.vue"),
          },
          {
            path: "infrastructure",
            name: "donor-infrastructure",
            component: () =>
              import("../views/admin/donor/InfrastructureView.vue"),
          },
          {
            path: "amenities",
            name: "donor-amenities",
            component: () => import("../views/admin/donor/AmenitiesView.vue"),
          },
        ],
      },
      {
        path: "trainers",
        name: "admin-trainers",
        redirect: { name: "trainer-index" },
      },
      {
        path: "employers",
        name: "admin-employers",
        component: () => import("../views/dashboards/employers/IndexView.vue"),
      },
      {
        path: "molsa",
        name: "admin-molsa",
        component: () =>
          import("../views/admin/molsa-admin/DashboardView.vue"),
      },
      {
        path: "partners",
        name: "admin-partners",
        component: () => import("../views/dashboards/partner/IndexView.vue"),
      },
      {
        path: "donors",
        name: "admin-donors",
        component: () => import("../views/dashboards/donor/IndexView.vue"),
      },
      {
        path: "state-officer",
        name: "admin-state-officer",
        redirect: { name: "fms-admin-index" },
      },
      {
        path: "expenses",
        name: "admin-expenses",
        component: () => import("../views/admin/ExpensesView.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "inventory",
        name: "admin-inventory",
        component: () => import("../views/admin/InventoryView.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "donations",
        name: "admin-donations",
        component: () => import("../views/admin/DonationsView.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "examinations",
        name: "admin-examinations",
        component: () => import("../views/admin/ExaminationsView.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "assessments",
        name: "admin-assessments",
        component: () => import("../views/admin/AssessmentsView.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "examination-results/:id",
        name: "admin-examination-results",
        component: () => import("../views/admin/ExaminationResultsView.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "assessment-submissions/:id",
        name: "admin-assessment-submissions",
        component: () => import("../views/admin/AssessmentSubmissionsView.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "lessons-attendance",
        name: "admin-lessons-attendance",
        component: () => import("../views/admin/LessonsAttendanceView.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "course-attendance",
        name: "admin-course-attendance",
        component: () => import("../views/admin/CourseAttendanceView.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "examinations-report",
        name: "admin-examinations-report",
        component: () => import("../views/admin/ExaminationsReportView.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "assessments-report",
        name: "admin-assessments-report",
        component: () => import("../views/admin/AssessmentsReportView.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "departments",
        redirect: { name: "admin-sections" },
      },
      {
        path: "sections",
        name: "admin-sections",
        component: () => import("../views/admin/DepartmentsView.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "student-enrollments",
        name: "admin-student-enrollments",
        component: () => import("../views/admin/StudentEnrollmentsView.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "intake-periods",
        name: "admin-intake-periods",
        component: () => import("../views/admin/IntakePeriodsView.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "infrastructure",
        name: "admin-infrastructure",
        component: () => import("../views/admin/InfrastructureView.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "resources-hub",
        name: "admin-resources-hub",
        component: () => import("../views/admin/ResourcesHubView.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "student-admissions",
        name: "admin-student-admissions",
        component: () => import("../views/admin/StudentAdmissionsView.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "announcements",
        name: "admin-announcements",
        component: () => import("../views/admin/AnnouncementsView.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "institution-amenities",
        name: "admin-institution-amenities",
        component: () => import("../views/admin/InstitutionAmenitiesView.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "student-certifications",
        name: "admin-student-certifications",
        component: () => import("../views/admin/StudentCertificationsView.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "external-qualifications",
        name: "admin-external-qualifications",
        component: () =>
          import("../views/admin/ExternalQualificationsView.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "course-curriculum",
        name: "admin-course-curriculum",
        component: () => import("../views/admin/CourseCurriculumView.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "jobs",
        name: "jobs",
        component: () => import("../views/admin/JobPostingsView.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "applications",
        name: "applications",
        component: () => import("../views/admin/JobApplicationsView.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "career-guidance",
        name: "career-guidance",
        component: () => import("../views/admin/CareerGuidanceView.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "accreditation",
        name: "accreditation",
        component: () => import("../views/admin/AccreditationView.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "compliance",
        name: "compliance",
        component: () => import("../views/admin/ComplianceViewNew.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "users",
        name: "users",
        component: () => import("../views/admin/UsersView.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "audit-logs",
        name: "audit-logs",
        component: () => import("../views/admin/AuditLogsView.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: ":pathMatch(.*)*",
        name: "admin-not-found",
        component: () => import("../views/NotFoundView.vue"),
        meta: { requiresAuth: true },
      },
    ],
  },
  {
    path: "/:pathMatch(.*)*",
    name: "not-found",
    component: () => import("../views/NotFoundView.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// Initialize route guards
// initializeGuards(router)

export default router;
